import axios from 'axios';

function errorMessage(response, fallback) {
  return response?.message || response?.errors?.map(error => error.message).join('; ') || fallback;
}

async function favoriteOperation({commit, dispatch, getters}, productId, state) {
  try {
    const data = {id: productId};
    if (typeof state === 'boolean') { data.state = state ? '1' : '0'; }
    const response = await axios.post('api/catalog/favorite/', data, {
      headers: {'Content-Type': 'multipart/form-data'}
    });
    if (response.data?.status !== 'success' || !['add', 'delete'].includes(response.data.data)) {
      throw new Error(errorMessage(response.data, 'Не удалось обновить избранное'));
    }
    commit(response.data.data === 'add' ? 'ADD_FAVORITE' : 'REMOVE_FAVORITE', Number(productId));
    commit('SET_FAVORITE_ERROR', null);
    await dispatch('fetchCounterData', true);
    if (getters.favoriteLoaded) { await dispatch('fetchFavorite'); }
    return {success: true, state: response.data.data === 'add'};
  } catch (error) {
    commit('SET_FAVORITE_ERROR', error.message);
    return {success: false, message: error.message};
  }
}

export default {
  state: {favoriteAddError: null, favoriteAddLoading: false},
  mutations: {
    SET_FAVORITE_LOADING(state, status) { state.favoriteAddLoading = status; },
    SET_FAVORITE_ERROR(state, error) { state.favoriteAddError = error; }
  },
  actions: {
    addToFavorite(context, productId) { return favoriteOperation(context, productId); },
    setFavoriteState(context, {productId, state}) { return favoriteOperation(context, productId, state); },
    async addToBasket({commit, dispatch}, {productId, quantity, collection}) {
      try {
        const response = await axios.post('api/basket/add/', {id: productId, collection, quantity}, {
          headers: {'Content-Type': 'multipart/form-data'}
        });
        if (response.data?.status !== 'success' || response.data.data !== true) {
          throw new Error(errorMessage(response.data, 'Не удалось добавить товар в корзину'));
        }
        if (productId) { commit('ADD_BASKET', Number(productId)); }
        commit('SET_FAVORITE_ERROR', null);
        // Analytics is already sent by the existing response interceptor using X-Modatech-Cart.
        await dispatch('fetchCounterData', true);
        return {success: true};
      } catch (error) {
        // A collection can partially succeed; retrieve the actual server state either way.
        await dispatch('fetchCounterData', true);
        commit('SET_FAVORITE_ERROR', error.message);
        return {success: false, message: error.message};
      }
    }
  },
  getters: {
    favoriteAddLoading: state => state.favoriteAddLoading,
    favoriteAddError: state => state.favoriteAddError,
    isFavorite: (state, getters) => id => (getters.counterFavoriteData?.ids || []).includes(Number(id))
  }
};
